import { AppointmentListItem } from '@spike/appointments-list-model';

export enum SortOrder {
    ASCENDING = 1,
    DESCENDING = -1
}

export interface Sorter {
    id: string;
    order: SortOrder;
    sort: (list: Array<AppointmentListItem>, order: SortOrder) => Array<AppointmentListItem>;
}

export const clientSorter: Sorter = {
    id: 'client',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                `${app.customer.firstName} ${app.customer.lastName}`
                    .toLocaleLowerCase()
                    .localeCompare(`${otherApp.customer.firstName} ${otherApp.customer.lastName}`.toLocaleLowerCase()) *
                order
        )
};

export const petSorter: Sorter = {
    id: 'pet',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                app.pet.name.toLocaleLowerCase().localeCompare(otherApp.pet.name.toLocaleLowerCase()) * order
        )
};

export const serviceSorter: Sorter = {
    id: 'service',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                app.service.name.toLocaleLowerCase().localeCompare(otherApp.service.name.toLocaleLowerCase()) * order
        )
};

export const transportationTypeSorter: Sorter = {
    id: 'transportationType',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                (app.transportation?.type ?? '')
                    .toLocaleLowerCase()
                    .localeCompare((otherApp.transportation?.type ?? '').toLocaleLowerCase()) * order
        )
};

export const vehicleSorter: Sorter = {
    id: 'vehicle',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                app.service.name.toLocaleLowerCase().localeCompare(otherApp.service.name.toLocaleLowerCase()) * order
        )
};

export const staffSorter: Sorter = {
    id: 'staff',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                (app.staff?.name ?? 'Unassigned')
                    .toLocaleLowerCase()
                    .localeCompare((otherApp.staff?.name ?? 'Unassigned').toLocaleLowerCase()) * order
        )
};

export const bookedAtSorter: Sorter = {
    id: 'bookedAt',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort((app, otherApp) => app.startAt.clone().diff(otherApp.startAt.clone(), 'milliseconds') * order)
};

export const totalSorter: Sorter = {
    id: 'total',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort((app, otherApp) => (Number(app.total) - Number(otherApp.total)) * order)
};

export const statusSorter: Sorter = {
    id: 'status',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort((app, otherApp) => (app.status.id - otherApp.status.id) * order)
};

export const roomSorter: Sorter = {
    id: 'room',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort(
            (app, otherApp) =>
                (app.room?.name ?? 'Unassigned').localeCompare(otherApp.room?.name ?? 'Unassigned') * order
        )
};

export const checkInSorter: Sorter = {
    id: 'checkInSorter',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort((app, otherApp) => app.startAt.clone().diff(otherApp.startAt.clone(), 'milliseconds') * order)
};

export const checkOutSorter: Sorter = {
    id: 'checkOutSorter',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort((app, otherApp) => app.endAt.clone().diff(otherApp.endAt.clone(), 'milliseconds') * order)
};

export const nightsSorter: Sorter = {
    id: 'nightsSorter',
    order: SortOrder.ASCENDING,
    sort: (list: Array<AppointmentListItem>, order: SortOrder): Array<AppointmentListItem> =>
        list.sort((app, otherApp) => (app.nights - otherApp.nights) * order)
};
